var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationIcon = function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "4 3 26 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.562,
    d: "M20.627 23.716a33 33 0 0 0 7.572-1.819 12.45 12.45 0 0 1-3.209-8.36v-1.042a8.33 8.33 0 0 0-16.66 0v1.042a12.45 12.45 0 0 1-3.209 8.36 33 33 0 0 0 7.573 1.819m7.933 0a33.7 33.7 0 0 1-7.933 0m7.933 0a4.165 4.165 0 1 1-7.933 0"
  })));
};
export { SvgNotificationIcon as ReactComponent };
export default __webpack_public_path__ + "4028cc4909158a44aa70d52229dd7312.svg";